import { render, staticRenderFns } from "./MovimientoResumen.vue?vue&type=template&id=33d19018&"
import script from "./MovimientoResumen.vue?vue&type=script&lang=js&"
export * from "./MovimientoResumen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports